import { FormControlLabel as MuiFormControlLabel, type FormControlLabelProps as MuiFormControlLabelProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiFormControlLabelProps, 'slots' | 'disableTypography'>>;

export function ControlLabel(props: Props) {
  return <MuiFormControlLabel {...props} />;
}

export type { Props as ControlLabelProps };
